import * as ko from 'knockout';
import entityBase from 'entityBase';

export class c_request_subscription_view extends entityBase {
    counter    : KnockoutObservable<number>;
    person_id  : KnockoutObservable<string>;
    request_id : KnockoutObservable<string>;
    update_type: KnockoutObservable<string>;

    constructor(item: any){
        super();
        this.counter     = ko.observable(item.counter);
        this.person_id   = ko.observable(item.person_id).extend({ maxLength: 50 });
        this.request_id  = ko.observable(item.request_id).extend({ maxLength: 50 });
        this.update_type = ko.observable(item.update_type).extend({ maxLength: 50 });
    }
}


